<template lang="pug">
div
	v-item-group.tw-mt-10(v-model="bookingStore.billing.personType" v-if="bookingStore.withInvoice")
		div.tw-flex.tw-flex-row.tw-justify-start
			v-item(v-for="(item, i) of personTypes" :key="i" :value="item")
				div.tw-cursor-pointer(:class="{'buy-type-base-item': true, 'active': (item == bookingStore.billing.personType)}" @click="changeInvoiceDestinationType(item)")
					span.tw-font-bold {{'LEGAL' == item ? $t('invoicetypes_labels.pg', 'Fattura con Partita IVA') : $t('invoicetypes_labels.pf', 'Fattura con Codice Fiscale') }}


	.tw-p-2(v-if="bookingStore.withInvoice")
		v-form(v-if='bookingStore.billing' ref='billingForm' @submit.prevent)
			template(v-if="'LEGAL' == bookingStore.billing.personType")
				div.tw-mb-4.tw-font-bold {{$t('sale.invoice_form.search_profile', 'Ricerca un profilo associato alla Partita IVA oppure creane uno nuovo.')}}
				div: v-switch(
					:model-value="newProfile"
					@update:model-value="changeNewProfileStatus"
					color="primary-darken-1"
					hide-details
					:label="$t('form_labels.new_profile', 'Crea nuovo profilo')"
				)
				div.tw-flex.tw-flex-col.tw-items-start.tw-justify-start.tw-gap-2(v-show="!newProfile")
					v-text-field(
						v-model="bookingStore.billing.vatNumber"
						:rules="vatRules"
						:label="$t('form_labels.invoice.vat', 'P:IVA')"
						:class="!isMobile ? 'tw-min-w-[400px]' : 'tw-w-full'"
						:error-messages="fieldErrorMessages && fieldErrorMessages.vatNumber"
						hide-details
					)
						template(v-slot:append)
							v-btn.tw-self-center(
								color="primary-darken-1"
								@click="searchInvoiceProfile"
								:loading='stepper.nextLoading'
							) {{ $t('common.find', 'CERCA')}}
					p(v-if='profiles && profiles.length == 0 && !stepper.nextLoading') {{$t('sale.invoice_form.no_registry', 'Nessuna anagrafica trovata')}}


			div.tw-mt-10.tw-font-bold {{$t('sale.invoice_form.billing_data', 'DATI FATTURAZIONE')}}
			div.tw-flex.tw-gap-4.tw-m-0(v-if="'LEGAL' == bookingStore.billing.personType" class="emd:tw-flex-col emd:tw-gap-0")
				v-select(
					v-if='profiles && !newProfile'
					:disabled="!profiles"
					v-model="profileSelected"
					:hint="'*' + $t('common.required_field', 'Campo obbligatorio')"
					:items="profiles" item-title="name" item-value="id"
					return-object single-line
					:label="$t('form_labels.select_a_profile', 'Seleziona un profilo') + '*'"
					@update:model-value="assignProfile"
				)
				v-text-field(
					v-model="bookingStore.billing.name"
					:rules="requiredRules"
					:label="$t('form_labels.invoice.profile_name', 'Nome Profilo') + '*'"
					:hint="'*' + $t('common.required_field', 'Campo obbligatorio')"
					:error-messages="fieldErrorMessages && fieldErrorMessages.name"
					:disabled="!newProfile"
					v-if='newProfile || !profiles'
					variant="filled"
					class="tw-w-1/3"
				)
				v-text-field(
					v-model="bookingStore.billing.businessName"
					:rules="requiredRules"
					:label="$t('form_labels.invoice.business_name', 'Ragione Sociale') + '*'"
					:hint="'*' + $t('common.required_field', 'Campo obbligatorio')"
					:error-messages="fieldErrorMessages && fieldErrorMessages.businessName"
					:disabled="!newProfile"
					class="tw-w-1/3"
				)
				v-text-field(
					v-model="bookingStore.billing.vatNumber"
					:rules="vatRules"
					:label="$t('form_labels.invoice.vat', 'P.IVA') + '*'"
					:hint="'*' + $t('common.required_field', 'Campo obbligatorio')"
					:error-messages="fieldErrorMessages && fieldErrorMessages.vatNumber"
					:disabled="!newProfile"
					class="tw-w-1/3"
				)


			div.tw-flex.tw-gap-4(v-else-if="'INDIVIDUAL' == bookingStore.billing.personType" class="emd:tw-flex-col emd:tw-gap-0")
				v-text-field(
					v-model="bookingStore.billing.firstName"
					:rules="textRules"
					:label="$t('form_labels.invoice.name', 'Nome') + '*'"
					:hint="'*' + $t('common.required_field', 'Campo obbligatorio')"
					:error-messages="fieldErrorMessages && fieldErrorMessages.firstName"
					class="tw-w-1/6"
				)
				v-text-field(
					v-model="bookingStore.billing.lastName"
					:rules="textRules"
					:label="$t('form_labels.invoice.surname', 'Cognome') + '*'"
					:hint="'*' + $t('common.required_field', 'Campo obbligatorio')"
					:error-messages="fieldErrorMessages && fieldErrorMessages.lastName"
					class="tw-w-1/6"
				)

			div.tw-flex.tw-gap-4(class="emd:tw-flex-col emd:tw-gap-0")
				v-text-field(
					v-if="'LEGAL' == bookingStore.billing.personType"
					v-model="bookingStore.billing.companyFiscalCode"
					:rules="fiscalCodeRules"
					:label="$t('form_labels.invoice.company_tax_code', 'Codice Fiscale Aziendale')"
					:error-messages="fieldErrorMessages && fieldErrorMessages.companyFiscalCode"
					:disabled="!newProfile"
					class="tw-w-1/3"
				)
				v-text-field(
					v-else-if="'INDIVIDUAL' == bookingStore.billing.personType"
					v-model="bookingStore.billing.fiscalCode"
					:rules="fiscalCodeRules"
					:label="$t('form_labels.invoice.fiscal_code', 'Codice Fiscale') + '*'"
					:hint="'*' + $t('common.required_field', 'Campo obbligatorio')"
					:error-messages="fieldErrorMessages && fieldErrorMessages.fiscalCode"
					class="tw-w-1/3"
				)

				v-select(
					v-model="bookingStore.billing.address.country"
					:items="[{country: 'Italia', code: 'IT'}]"
					item-title="country"
					item-value="code"
					:label="$t('form_labels.address.country', 'Nazione') + '*'"
					single-line
					class="tw-w-1/3"
					disabled
				)
				v-select(
					v-model="bookingStore.billing.address.province"
					:items="provinces"
					item-title="name"
					item-value="code"
					:label="$t('form_labels.address.state', 'Provincia') + '*'"
					:hint="'*' + $t('common.required_field', 'Campo obbligatorio')"
					single-line
					:loading="loadingProvinces"
					:disabled="disableAddressFields"
					class="tw-w-1/3"
					eager
				)
			div.tw-flex.tw-gap-4(class="emd:tw-flex-col emd:tw-gap-0")
				v-text-field(
					v-model="bookingStore.billing.address.city"
					:rules="cityRules"
					:label="$t('form_labels.address.city', 'Città') + '*'"
					:hint="'*' + $t('common.required_field', 'Campo obbligatorio')"
					:error-messages="fieldErrorMessages && fieldErrorMessages.city"
					:disabled="disableAddressFields"
					class="tw-w-1/3"
				)
				v-text-field(
					v-model="bookingStore.billing.address.postalCode"
					:rules="postalCodeRules"
					:label="$t('form_labels.address.cep', 'CAP') + '*'"
					:hint="'*' + $t('common.required_field', 'Campo obbligatorio')"
					:error-messages="fieldErrorMessages && fieldErrorMessages.postalCode"
					:disabled="disableAddressFields"
					class="tw-w-1/3"
				)
				v-text-field(
					v-model="bookingStore.billing.address.address"
					:rules="requiredRules"
					:label="$t('form_labels.address.address', 'Indirizzo') + '*'"
					:hint="'*' + $t('common.required_field', 'Campo obbligatorio')"
					:error-messages="fieldErrorMessages && fieldErrorMessages.address"
					:disabled="disableAddressFields"
					class="tw-w-1/3"
				)

			h3.tw-mb-4.tw-mt-10.tw-font-bold {{$t('form_labels.invoice.delivery_methods', 'MODALITÀ DI CONSEGNA (obbligatorio Cod.Dest. o PEC)')}}
			div.tw-flex.tw-gap-4(class="emd:tw-flex-col emd:tw-gap-0")
				v-text-field(
					v-model="bookingStore.billing.recipientCode"
					:rules="codUnivRules"
					:label="$t('form_labels.invoice.recipient_code', 'Codice Destinatario')"
					:hint="'*' + $t('form_labels.invoice.pec_descr', 'Campo obbligatorio in assenza di PEC')"
					:error-messages="fieldErrorMessages && fieldErrorMessages.recipientCode"
					class="tw-w-1/6"
				)
				v-text-field(
					v-model="bookingStore.billing.certifiedMail"
					:rules="pecRules"
					:label="$t('form_labels.invoice.pec', 'PEC')"
					:hint="'*' + $t('form_labels.invoice.recipient_code_descr', 'Campo obbligatorio in assenza di Codice Destinatario')"
					:error-messages="fieldErrorMessages && fieldErrorMessages.certifiedMail"
					class="tw-w-1/6"
				)
</template>

<script setup>
import {makeInvoice, useBookingStore} from "@/stores/booking";
import {computed, inject, onMounted, ref, shallowRef, toRef, toRefs, watch} from 'vue';
import {useBookingStepperStore} from "@/stores/booking-stepper";
import {useI18n} from "vue-i18n";
import {rules_checkEmailField, rules_checkRequiredFields, getOnlyNumbers} from "@/common-scripts/utilities";


const bookingStore = useBookingStore();
const stepper = useBookingStepperStore();
const isMobile = inject('isMobile');
const i18n = useI18n();
const axios = inject('axios');
const provinces = shallowRef();
const loadingProvinces = ref(false);
const profiles = ref(null);
const profileSelected = ref(null);
const billingForm = ref(null);
const newProfile = ref(false);
const disableAddressFields = ref(true);

const requiredRules = [
	v => rules_checkRequiredFields(v, i18n),
];
const textRules = [
	v => rules_checkRequiredFields(v, i18n),
];
const postalCodeRules = [
	v => rules_checkRequiredFields(v, i18n),
	v => {
		bookingStore.billing.address.postalCode = getOnlyNumbers(v);
		return true;
	}
];
const cityRules = [
	// todo: si potrebbe usare un elenco dei comuni italiani
	v => rules_checkRequiredFields(v, i18n),
];
const vatRules = [
		v => rules_checkRequiredFields(v, i18n),
		v => {
			// todo: ci sono criteri per la p.iva italiana ?
			return true;
		}
];
const fiscalCodeRules = [
	v => 'LEGAL' == bookingStore.billing.personType ? rules_checkRequiredFields(v, i18n) : true,
	v => {
		if ('LEGAL' == bookingStore.billing.personType) return true;
		if (rules_checkRequiredFields(v, i18n) !== true) return rules_checkRequiredFields(v, i18n);
		v = v.toUpperCase();
		bookingStore.billing.fiscalCode = v;
		const regex = /([A-Z]{6}[0-9LMNPQRSTUV]{2}[ABCDEHLMPRST]{1}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{3}[A-Z]{1})$|([0-9]{11})$/g;

		return regex.test(v) ? true : i18n.t('rules.fiscal_code', 'Inserire un Codice Fiscale valido');
	}
];
const codUnivRules = [
	v => {
		if (bookingStore.billing.certifiedMail || v) {
			return true
		} else {
			return i18n.t('sale.travellers_data.need_pec_or_rc', "È obbligatorio inserire PEC o Codice Univoco")
		}
	}
];
const pecRules = [
	v => {
		if (!bookingStore.billing.recipientCode && !v) {
			return i18n.t('sale.travellers_data.need_pec_or_rc', "È obbligatorio inserire PEC o Codice Univoco")
		} else if (v) {
			return rules_checkEmailField(v, i18n)
		} else {
			return true;
		}
	}
];
const fieldErrorMessages = computed(() => {
	let messages = {};

	if (!bookingStore.billing.vatNumber) return messages;

	// messages['vatNumber'] = ['P.IVA obbligatoria'];
	if (!bookingStore.billing.certifiedMail && !bookingStore.billing.recipientCode) {
		// messages['certifiedMail'] = ['E\' obbligatorio inserire PEC o Codice UnivocoAAA'];
		// messages['recipientCode'] = ['E\' obbligatorio inserire PEC o Codice UnivocoAAA'];
	}

	return messages;
})
const personTypes = ['LEGAL', 'INDIVIDUAL'];



function invoiceRequest() {
	bookingStore.withInvoice = !bookingStore.withInvoice;
	if(billingForm.value) resetForm();
	if(bookingStore.withInvoice) loadProvinces();
}
function changeInvoiceDestinationType(type) {
	bookingStore.billing.personType = type;
	disableAddressFields.value = 'LEGAL' == type ? true : false;
	if(billingForm.value) resetForm();
}
function changeNewProfileStatus() {
	newProfile.value = !newProfile.value;

	if (!newProfile.value) {
		bookingStore.billing.name = null;
		bookingStore.billing.businessName = null;
		bookingStore.billing.companyFiscalCode = null;
		disableAddressFields.value = true;
	} else {
		disableAddressFields.value = false;
	}
	if(billingForm.value) billingForm.value.resetValidation()
}
function searchInvoiceProfile() {
	stepper.nextLoading = true;
	axios.post('trenitalia/search-invoice-profiles', {
		vatNumber: bookingStore.billing.vatNumber,
	}).then((response) => response.data).then(res => {
		stepper.nextLoading = false;
		if (res && !Array.isArray(res)) {
			res = [res];
		}
		if(res && res.length > 50){
			res.splice(50);
		}
		profiles.value = res;

	}).catch(e => {
		console.error(e);
		stepper.nextLoading = false;
		profiles.value = [];
	});
}
function assignProfile() {
	bookingStore.billing.id = profileSelected.value.id;
	bookingStore.billing.name = profileSelected.value.name;
	bookingStore.billing.businessName = profileSelected.value.businessName;
	bookingStore.billing.personType = profileSelected.value.personType;
	bookingStore.billing.vatNumber = profileSelected.value.vatNumber;
	bookingStore.billing.address = profileSelected.value.address;
	bookingStore.billing.certifiedMail = profileSelected.value.certifiedMail;
	bookingStore.billing.recipientCode = profileSelected.value.recipientCode;
}
function resetForm() {
	billingForm.value.reset();
	bookingStore.billing.address.country = 'IT';
}
async function loadProvinces() {
	if (provinces.value) return;

	loadingProvinces.value = true;
	provinces.value = sessionStorage.getItem('provinces');
	if (!provinces.value) {
		try {
			const prov = await axios.get('trenitalia/get-provinces');

			if (!prov || prov.status != 200) {
				console.error('provinces error', provinces.value);
				loadingProvinces.value = false;
			}
			sessionStorage.setItem('provinces', JSON.stringify(prov.data));
			loadingProvinces.value = false;
			provinces.value = prov.data;
		} catch (e) {
			console.error('provinces exceptions', e);
			loadingProvinces.value = false;
		}
	} else {
		provinces.value = JSON.parse(provinces.value);
	}
	loadingProvinces.value = false;
}


watch(() => bookingStore.withInvoice, (value, old) => {
	if(billingForm.value) resetForm();
});


defineExpose({
	billingForm
});
onMounted(async () => {
	if (!bookingStore.withInvoice) return;
	// if (!bookingStore.billing) bookingStore.billing = makeInvoice();
	await loadProvinces();
});
</script>

<style scoped>
.buy-type-base-item:first-child {
	border-bottom-right-radius: 0px;
	border-top-right-radius: 0px;
}

.buy-type-base-item:last-child {
	border-bottom-left-radius: 0px;
	border-top-left-radius: 0px;
}

.buy-type-base-item {
	padding: 10px 30px;
	border-radius: 16px;
	border: solid 2px #bcbcbc;
	color: #bcbcbc;
}

.buy-type-base-item.active {
	color: var(--color-primary);
	border: solid 2px var(--color-primary);
	background-color: rgba(88, 174, 228, 0.2);
}
</style>
